export const MBO_STUDIES = {
  'MBO Niveau 1': [
    'Assistent Horeca, Voeding of Voedingsindustrie',
    'Assistent Logistiek',
    'Assistent Verkoop/Retail',
    'Assistent Zorg en Welzijn',
    'Assistent Bouw en Wonen',
    'Assistent Groen, Ruimte en Recreatie'
  ],
  'MBO Niveau 2': [
    // Bouw & Afwerking - Ruwbouw
    'Metselaar',
    'Betontimmerman',
    'Betonstaalvlechter',
    'Aankomend medewerker grondoptreden',
    'Tegelzetter',
    'Waterbouwer',
    'Vakman GWW',
    'Opperman bestratingen',
    // Bouw & Afwerking - Afwerking & Interieur
    'Timmerman',
    'Meubelmaker / (scheeps)interieurbouwer',
    'Interieurvakman parketvloeren',
    'Interieurvakman woningstofferen',
    'Keukenmonteur',
    'Stukadoor',
    'Glaszetter',
    'Voeger',
    'Schilder',
    'Dekvloerenlegger',
    'Natuursteenbewerker ambachtelijk',
    'Natuursteenbewerker machinaal',
    'Monteur metalen daken en gevels',
    'Dakdekker bitumen en kunststof',
    'Dakdekker riet',
    // Bouw & Afwerking - Montage & Plaatsing
    'Montagemedewerker houttechniek',
    'Carrosseriebouwer',
    // Techniek & Installatie - Werktuigbouw / Klimaat
    'Monteur koude- en klimaatsystemen',
    'Monteur gas-, water- of warmtedistributie',
    'Monteur werktuigkundige installaties',
    'Airco/warmtepompmonteur',
    'Monteur service en onderhoud installaties en systemen',
    'Verbrandingsmotortechnicus',
    // Techniek & Installatie - Elektrotechniek & Mechatronica
    'Monteur elektrotechnische installaties',
    'Monteur middenspanningsdistributie',
    'Monteur laagspanningsdistributie',
    'Monteur datadistributie',
    'Monteur mechatronica',
    'Machineoperator houttechniek',
    // Techniek & Installatie - Luchtvaart / Maritiem / Voertuigen
    'Monteur luchtvaartuigen',
    'Basis technicus voertuigen en mobiele werktuigen',
    'Autoschadehersteller',
    'Stuurman werktuigkundige zeevisvaart sw6',
    // Logistiek & Transport - Transport & Rijden
    'Chauffeur wegvervoer',
    'Chauffeur openbaar vervoer',
    'Touringcarchauffeur',
    'Taxichauffeur',
    // Logistiek & Transport - Logistiek & Opslag
    'Logistiek medewerker',
    'Medewerker internationale havenlogistiek',
    'Medewerker havenoperaties',
    'Medewerker agrohandel en logistiek',
    // Productie & Industrie - Technische productie
    'Industrieel lakverwerker',
    'Medewerker productietechniek',
    'Medewerker operationele techniek',
    'Medewerker voeding, technologie en techniek',
    'Medewerker versindustrie',
    'Allround medewerker afvalbeheer',
    // Productie & Industrie - Voeding & Bakkerij
    'Kok',
    'Uitvoerend bakker',
    'Medewerker vers',
    // Productie & Industrie - Drukwerk / Media / Sign
    'Basismedewerker printmedia',
    'Medewerker sign',
    // ICT & Creatieve Media
    'Medewerker ICT',
    'Mediamaker',
    'Medewerker fotografie',
    'Medewerker podium- en evenemententechniek',
    // Dienstverlening & Zorg - Zorg & Welzijn
    'Helpende zorg en welzijn',
    // Dienstverlening & Zorg - Beveiliging & Faciliteiten
    'Beveiliger 2',
    'Medewerker facilitaire dienstverlening',
    'Servicemedewerker gebouwen',
    'Gastheer/-vrouw',
    'Schoonmaker in verschillende omgevingen',
    'Meewerkend leidinggevende algemeen schoonmaakonderhoud',
    'Schoenhersteller',
    // Groen, Dier & Milieu - Groen & Natuur
    'Medewerker hovenier',
    'Medewerker natuur, water en recreatie',
    'Medewerker groen, grond en groene infra',
    // Groen, Dier & Milieu - Dier & Landbouw
    'Medewerker dierverzorging',
    'Medewerker teelt',
    'Medewerker veehouderij',
    // Handel, Retail & Verkoop
    'Retailmedewerker',
    'Verkoopmedewerker optiek',
    'Medewerker productpresentatie',
    'Medewerker bloem, groen en styling',
    // Mode & Fashion
    'Basismedewerker fashion',
    // Scheepvaart & Binnenvaart
    'Schipper-machinist beperkt werkgebied',
    'Schipper rondvaartboot beperkt vaargebied',
    'Matroos binnenvaart',
    'Aankomend medewerker maritiem'
  ],
  'MBO Niveau 3': [
    // Techniek, Bouw & Productie - Werktuigbouw & Elektrotechniek
    'Eerste monteur datadistributie',
    'Eerste monteur middenspanningsdistributie',
    'Eerste monteur laagspanningsdistributie',
    'Eerste monteur gas-, water- of warmtedistributie',
    'Eerste monteur elektrotechnische installaties woning en utiliteit',
    'Eerste monteur elektrotechnische industriële installaties en systemen',
    'Eerste monteur service en onderhoud werktuigkundige installaties',
    'Eerste monteur service en onderhoud elektrotechniek en instrumentatie',
    'Eerste monteur koude- en klimaatsystemen',
    'Tekenaar werktuigbouw',
    // Techniek, Bouw & Productie - Bouw & Infrastructuur
    'Allround metselaar',
    'Allround betonstaalverwerker bouwplaats',
    'Machinist hijswerk',
    'Machinist wegenbouw',
    'Allround dakdekker metaal',
    'Allround dakdekker bitumen en kunststof',
    'Straatmaker',
    'Gezel glaszetter',
    'Eerste monteur utiliteit',
    'Allround betontimmerman',
    'Allround betonreparateur',
    'Allround vakkracht onderhoud- en klussenbedrijf',
    // Techniek, Bouw & Productie - Mechatronica & Automatisering
    'Eerste monteur mechatronica',
    'Allround technicus voertuigen en mobiele werktuigen',
    'Eerste verbrandingsmotortechnicus',
    'Allround uurwerktechnicus',
    'Allround laborant',
    // Techniek, Bouw & Productie - Houtbewerking & Meubelindustrie
    'Allround machineoperator houttechniek',
    'Allround machineoperator meubelindustrie / (scheeps)interieurbouw',
    'Allround meubelmaker / (scheeps)interieurbouwer',
    // Zorg, Welzijn & Dieren - Gezondheidszorg
    'Verzorgende IG',
    'Medewerker steriele medische hulpmiddelen',
    'Pedicure',
    'Orthopedisch schoentechnisch medewerker',
    'Tandtechnisch medewerker basistechnieken',
    // Zorg, Welzijn & Dieren - Maatschappelijke Zorg & Opvang
    'Begeleider maatschappelijke zorg',
    'Pedagogisch medewerker kinderopvang',
    'Werkbegeleider zorgboerderij',
    // Zorg, Welzijn & Dieren - Dierverzorging
    'Zelfstandig medewerker dierverzorging',
    'Proefdierverzorger',
    // Veiligheid, Defensie & Toezicht - Toezicht & Handhaving
    'Handhaver toezicht en veiligheid openbaar vervoer (domein IV)',
    'Handhaver toezicht en veiligheid openbare ruimte (domein I)',
    'Handhaver toezicht en veiligheid milieu, welzijn en infrastructuur (domein II)',
    'Handhaver toezicht en veiligheid generieke opsporing (domein VI)',
    // Veiligheid, Defensie & Toezicht - Defensie & Maritiem
    'Aankomend onderofficier maritiem',
    'Aankomend onderofficier grondoptreden',
    // Veiligheid, Defensie & Toezicht - Havenveiligheid
    'Beveiliger 3',
    'Voorman BOR',
    'Balkman',
    'Bootman',
    // Commercieel, Zakelijk & Mode - Retail & Verkoop
    'Commercieel medewerker',
    'Retailspecialist',
    'Fashion retailer',
    'Assistant fashion tailor',
    // Commercieel, Zakelijk & Mode - Horeca & Gastvrijheid
    'Zelfstandig werkend gastheer/-vrouw',
    'Zelfstandig werkend kok',
    'Eerste medewerker fastservice',
    // Commercieel, Zakelijk & Mode - Administratie & Bedrijfsondersteuning
    'Allround assistant business services',
    'Logistiek teamleider',
    'Coördinator internationale havenlogistiek',
    // Commercieel, Zakelijk & Mode - Creatieve Ambachten
    'Basisgoudsmid',
    // Vervoer, Transport & Maritiem - Scheepvaart & Maritiem
    'Schipper binnenvaart',
    'Maritiem officier kleine schepen technisch',
    'Maritiem officier kleine schepen nautisch, visserij',
    'Maritiem officier kleine schepen nautisch, koopvaardij',
    // Vervoer, Transport & Maritiem - Weg- & Personenvervoer
    'Touringcarchauffeur/reisleider',
    // Groen, Agrarisch & Landschap - Tuinbouw & Natuur
    'Vakbekwaam medewerker teelt',
    'Vakbekwaam medewerker natuur, water en recreatie',
    'Vakbekwaam medewerker groen, grond en groene infra',
    'Vakbekwaam medewerker bloem, groen en styling',
    // Groen, Agrarisch & Landschap - Veeteelt
    'Vakbekwaam medewerker veehouderij',
    // Groen, Agrarisch & Landschap - Hoveniers & Groenvoorziening
    'Vakbekwaam hovenier',
    // Creatieve & Vormgevende Technieken - Interieur & Meubel
    'Allround meubelmaker / (scheeps)interieurbouwer',
    'Allround meubelstoffeerder',
    'Allround interieurvakman parketvloeren',
    'Allround interieurvakman woningstofferen',
    // Creatieve & Vormgevende Technieken - Visuele Vormgeving
    'Allround signmaker',
    'Allround stand- en decorbouwer',
    // Creatieve & Vormgevende Technieken - Technisch Onderhoud & Reparatie
    'Gezel schilder',
    'Eerste monteur dakbedekking',
    // Creatieve & Vormgevende Technieken - Voertuigentechniek
    'Eerste autospuiter',
    // Logistiek & Productie - Productieprocessen
    'Allround medewerker productietechniek',
    'Procesoperator B',
    // Logistiek & Productie - Logistiek & Distributie
    'Logistiek teamleider',
    'Coördinator internationale havenlogistiek',
    // Media, IT & Ondersteuning - Media & Vormgeving
    'Allround mediamaker',
    'Allround medewerker AV-productie',
    // Media, IT & Ondersteuning - IT & Systeemonderhoud
    'Allround medewerker IT systems and devices',
    // Voeding & Vers
    'Allround medewerker versindustrie'
  ],
  'MBO Niveau 4': [
    // Gezondheidszorg en Welzijn - Zorg & Begeleiding
    'Mbo-Verpleegkundige',
    'Verzorgende IG (Individuele Gezondheidszorg)',
    'Persoonlijk begeleider maatschappelijke zorg',
    'Sociaal Pedagogisch Hulpverlener (SPH)',
    'Jeugdzorgwerker',
    'Leefstijlcoach',
    'Voeding- en leefstijladviseur',
    'Medisch Secretaresse',
    'Manager Gezondheidszorg',
    'Persoonlijk werkbegeleider zorgboerderij',
    // Gezondheidszorg en Welzijn - Assistenten & Paramedici
    'Doktersassistent',
    'Apothekersassistent',
    'Tandartsassistent',
    'Technisch oogheelkundig assistent',
    'Orthopedisch technisch specialist',
    'Tandtechnicus prothese',
    'Medisch pedicure',
    // Gezondheidszorg en Welzijn - Dieren & Paardensport
    'Dierenartsassistent paraveterinair',
    'Instructeur paardensport en -houderij',
    // Techniek en Engineering - Elektrotechniek & Mechatronica
    'Technicus elektrotechniek',
    'Technicus data',
    'Technicus mechatronica',
    'Technicus elektrotechnische industriële systemen en installaties',
    'Technicus elektrotechnische installaties in de gebouwde omgeving',
    'Technicus service en onderhoud elektrotechniek en instrumentatie',
    // Techniek en Engineering - Werktuigbouw & Mechanica
    'Technicus service en onderhoud werktuigbouw',
    'Technicus service en onderhoud werktuigkundige installaties',
    'Technicus mechanica luchtvaartuigen',
    'Technicus industriële koude- en klimaatsystemen',
    'Onderhoudsmonteur',
    'Installatiemonteur',
    'Junior Technisch Tekenaar',
    // Techniek en Engineering - Voertuigen & Luchtvaart
    'Technicus avionica luchtvaartuigen',
    'Technisch specialist voertuigen en mobiele werktuigen',
    'Technisch specialist autoschadeherstel',
    'Technisch specialist verbrandingsmotoren',
    // Techniek en Engineering - Water & Gas
    'Technicus gas',
    'Technicus water',
    // Techniek en Engineering - Engineering & Ontwerp
    'Technicus engineering',
    'Technisch leidinggevende',
    // Onderwijs en Coaching - Docenten & Begeleiders
    'Onderwijsassistent',
    'Praktijkopleider',
    'Vakdocent',
    'Pedagogisch Werker',
    'Trainer-coach/Instructeur',
    'Instructeur mbo',
    // Onderwijs en Coaching - Sport & Beweging
    'Buurtsportcoach',
    'Bewegingsagoog',
    // Onderwijs en Coaching - Duurzaamheid & Maatschappij
    'Coördinator duurzaamheid',
    // Ondernemerschap en Bedrijfskunde - Management & Leiding
    'Manager mobiliteitsbranche',
    'Manager/bedrijfsleider fastservice',
    'Manager/ondernemer horeca',
    'Manager/bedrijfsleider bloem, groen en styling',
    'Bedrijfsleider dierverzorging',
    'Bedrijfsleider paardensport en -houderij',
    'Bedrijfsleider/ondernemer bloem, groen en styling',
    'Business administration & control specialist',
    'Commercieel Manager',
    'Projectleider Bedrijfskunde',
    // Ondernemerschap en Bedrijfskunde - Commercieel & Verkoop
    'Junior accountmanager',
    'Retailmanager',
    'Junior manager groothandel',
    'Junior manager internationale handel',
    'E-commerce Specialist',
    'Interieuradviseur',
    // Ondernemerschap en Bedrijfskunde - Zelfstandig Ondernemerschap
    'Vakspecialist ondernemer',
    'Ondernemer handel',
    'Ondernemer bakkerij',
    'Ondernemer vers',
    'Ondernemerhandel',
    'Meewerkend horeca ondernemer',
    'Ondernemend meubelmaker / (scheeps)interieurbouwer',
    'Zelfstandig Ondernemer',
    // Media, Communicatie en Marketing - Media & Creatie
    'Mediamanager',
    'Mediaredactiemedewerker',
    'Mediavormgever',
    // Media, Communicatie en Marketing - Marketing & Communicatie
    'Marketing & communication specialist',
    'Communicatieadviseur',
    'Public Relations Specialist',
    'Content Manager',
    'E-commerce specialist',
    // Creatieve en Technische Sectoren - Groen, Bloem & Styling
    'Vakexpert bloem, groen en styling',
    'Vakexpert groen, grond en groene infra',
    // Creatieve en Technische Sectoren - Vormgeving & Ambacht
    'Ruimtelijk vormgever',
    'Signspecialist',
    'Decoratie- en restauratieschilder',
    'Zilversmid',
    'Goudsmid',
    'Creatief vakman',
    // Creatieve en Technische Sectoren - Voeding & Technologie
    'Vakexpert voeding, kwaliteit en productontwikkeling',
    'Vakexpert voeding, technologie en techniek',
    // Creatieve en Technische Sectoren - Geo & Design
    'Vakexpert geo, data & design',
    // Creatieve en Technische Sectoren - Agrarisch & Agro
    'Vakexpert biologisch-dynamische landbouw',
    'Vakexpert teelt en groene technologie',
    'Vakexpert agrohandel en logistiek',
    // Creatieve en Technische Sectoren - Mode & Styling
    'Allround make-up and hair artist',
    'Fashion tailor',
    'Fashion designer',
    'Fashion product coördinator',
    'Interieuradviseur',
    // Technische Specialismen - Klimaat & Koudetechniek
    'Systeemontwerper koude- en klimaatsystemen',
    // Technische Specialismen - Engineering & Techniek
    'Commercieel technicus engineering',
    'Software developer',
    // Technische Specialismen - Voertuigentechniek
    'Technisch specialist autoschadeherstel',
    'Technisch specialist voertuigen en mobiele werktuigen',
    'Technisch specialist verbrandingsmotoren',
    'Technisch specialist elektrotechniek',
    // Technische Specialismen - Tekenwerk & Voorbereiding
    'Tekenaar ontwerper elektrotechniek',
    'Tekenaar ontwerper werktuigkundige installaties',
    'Tekenaar constructeur',
    'Werkvoorbereider installaties',
    'Werkvoorbereider gespecialiseerde aannemerij',
    'Werkvoorbereider houttechniek',
    'Werkvoorbereider meubelindustrie / (scheeps)interieurbouw',
    'Werkvoorbereider fabricage',
    // Bouw en Infra - Uitvoering & Coördinatie
    'Uitvoerder bouw/infra',
    'Uitvoerder',
    'Uitvoerder gespecialiseerde aannemerij',
    'Coördinator havenoperaties',
    'Coördinator duurzaamheid',
    'Opzichter/uitvoerder groene ruimte',
    // Bouw en Infra - Restauratie & Afwerking
    'Decoratiestukadoor',
    'Specialist restauratie timmerwerk',
    'Specialist restauratie metselwerk',
    'Specialist restauratie schilderwerk',
    // Bouw en Infra - Middenkader Bouw & Infra
    'Middenkaderfunctionaris verkeer en stedenbouw',
    'Middenkaderfunctionaris landmeetkunde',
    'Middenkaderfunctionaris grond-, weg- en waterbouw',
    'Middenkaderfunctionaris bouw',
    'Middenkaderfunctionaris smart building',
    // Logistiek en Transport - Logistiek & Distributie
    'Logistiek supervisor',
    'Transport en logistiek',
    'Specialist internationale havenlogistiek',
    // Logistiek en Transport - Luchtvaart & Maritiem
    'Air cargo specialist',
    'Luchtvaartdienstverlener',
    'Aviation operations specialist',
    'Kapitein binnenvaart',
    'Maritiem officier alle schepen nautisch, visserij',
    'Maritiem officier alle schepen nautisch, waterbouw',
    'Maritiem officier alle schepen nautisch, koopvaardij',
    // Mode en Styling - Modeontwerp & Productie
    'Fashion tailor',
    'Fashion product coördinator',
    'Fashion designer',
    // Mode en Styling - Podium & Evenement
    'Allround podium- en evenemententechnicus',
    // Mode en Styling - Kappers & Salons
    'Salonmanager dame',
    'Salonmanager heer'
  ]
}
